$(document).ready(() => {
  let $form = $("#changeDistributorForm");

  if ($form.length === 0) {
    return;
  }

  let $select = $(".distributor-select", $form);
  let $submit = $("button[type=submit]", $form);

  $select.on("change", (e) => {
    if (e.target.value === "") {
      $submit.attr("disabled", "disabled");
    } else {
      $submit.removeAttr("disabled");
    }
  });
});
